import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { leadTypeQuery } from '../../../graph-ql/queries';
import { LeadTypeResponse } from '../../models/leadType/lead.type.response';

@Injectable()
export class LeadTypeService {

  constructor(public apollo: Apollo) {
  }

  leadTypeQuery$(): Observable<LeadTypeResponse> {
    return this.apollo.query<LeadTypeResponse>({
      query: leadTypeQuery
    })
    .pipe(map(result => {

      if (!result.data['getLeadTypes']) {
        return new LeadTypeResponse([]);
      }

      return new LeadTypeResponse(
        result.data['getLeadTypes']['types']
      );
    }

      ));
  }
}
